import React from 'react';
import { NikeOneHeader } from '@/nikeone/components/NikeOneHeader';
import { FavoritesHeader } from '@/favorites/components/FavoritesHeader';
import CasinoHeader from './CasinoHeader';
import { TicketsOverviewHeader } from '@/mytickets/TicketsOverviewHeader';
import { CommunityHeader } from '@/betbook/views/CommunityHeader';
import {
    ACCOUNT_PASSWORD,
    ACCOUNT_PROFILE,
    ACCOUNT_SETTINGS,
    ARTICLE_ARCHIVE,
    COMMUNITY_ANALYSES,
    COMMUNITY_ANALYSIS_DETAIL,
    COMMUNITY_LOBBY,
    COMMUNITY_POSTS_AUTHOR,
    COMMUNITY_TICKET_DETAIL,
    BETBOOK_TICKETS,
    COMMUNITY_TOP_EVENTS,
    BONUS_DASHBOARD_CURRENT,
    BONUS_DASHBOARD_HISTORY,
    BRING_FRIENDS,
    CASINO_FAVORITE,
    CASINO_GAME_DETAIL,
    CASINO_GAME_ENDED,
    CASINO_GAME_HRY_CATEGORY,
    CASINO_GAME_KASINO_CATEGORY,
    CASINO_HRY_LOBBY,
    CASINO_LOBBY,
    COMMUNITY_CHAT,
    CONTACT_US,
    CONTACT_US_INFO,
    FAVORITES_HISTORY,
    GOAL_OF_MONTH,
    HOME,
    LIVE_STREAMS,
    MARKETING_ARTICLE,
    MENU,
    MONEY_DEPOSIT,
    MONEY_TRANSFER,
    MONEY_WITHDRAWAL,
    MY_TICKETS,
    NIKE1,
    NIKE1_DETAIL,
    NIKE1_FAV,
    NIKE1_MATCH,
    NIKE1_MENU_ITEM_TOURNAMENT,
    NIKE1_RESULTS,
    NIKE1_TOURNAMENT,
    NOTIFIED_MATCHES,
    NOTIFIED_TICKETS,
    OFFICES,
    PROMO_CMS,
    PROMO_CMS_BETS,
    PROMO_CMS_SCHEDULE,
    PROMO_CMS_TABLES,
    SAVED_TICKETS,
    SCRATCHCARD_CONTACT,
    SCRATCHCARD_DETAIL,
    SCRATCHCARD_FAQ,
    SCRATCHCARD_I_SCRATCH,
    SCRATCHCARD_I_SCRATCH_PLAY,
    SCRATCHCARD_KIOSK_LIST,
    SCRATCHCARD_OVERVIEW,
    SCRATCHCARD_PARTNER_ZONE,
    TOURNAMENTS,
    TOURNAMENTS_RANKING,
    TOURNAMENTS_REWARDS,
    TOURNAMENTS_TICKETS,
    TURBO_LIVE_FAVORITES,
    TURBO_LIVE_MATCH_DETAIL,
    TURBO_LIVE_SPORT,
    TV_NIKE_ARCHIVE_DETAIL,
    TV_NIKE_ARCHIVE_OVERVIEW,
    TV_NIKE_HIGHLIGHTS_DETAIL,
    TV_NIKE_HIGHLIGHTS_OVERVIEW,
    TV_NIKE_STREAM_DETAIL,
    TV_NIKE_STREAM_OVERVIEW,
    VIRTUAL_GAMES
} from '@/routing/routes';
import { isRegistrationRoute } from '@/routing/routeutils';
import TransparentHeader from '@/header/TransparentHeader';
import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import ContactsAndOfficesHeader from '@/header/ContactsAndOfficesHeader';
import BonusDashboardHeader from '@/header/BonusDashboardHeader';
import ProfileHeader from '@/header/ProfileHeader';
import NotificationsHeader from '@/header/NotificationsHeader';
import SimplePageHeader from '@/header/SimplePageHeader';
import MyMoneyHeader from '@/money/views/MyMoneyHeader';
import BringFriendsHeader from '@/bringfriends/views/BringFriendsHeader';
import { TournamentHeader } from '@/tournaments/components/tournament-header/TournamentHeader';
import BetbookPostAuthorHeader from '@/header/BetbookPostAuthorHeader';
import NikeTvHeader from '@/header/NikeTvHeader';
import ArticleHeader from '@/article/views/ArticleHeader';
import { isNikeoneEnabled } from 'nike-ui/src/components/nikeone';
import { getOfferRouter } from '@/routing/route-groups';
import LotteryHeader from '@/@chunk-lottery-ticket/components/LotteryHeader';
import { isProfileIScratchCardEnabled } from 'nike-ui/src/profiles';

const TopHeader = React.memo(function TopHeader({ route }) {
    if (!isNikeoneEnabled && getOfferRouter().includes(route)) {
        return <NikeOneHeader active={route} />;
    }

    if (isRegistrationRoute(route)) {
        return <TransparentHeader />;
    }
    switch (route) {
        case HOME:
        case NIKE1_RESULTS:
            return <UserBoardHeader />;
        case SCRATCHCARD_OVERVIEW:
        case SCRATCHCARD_DETAIL:
            return <LotteryHeader active={route} />;
        case SCRATCHCARD_KIOSK_LIST:
        case SCRATCHCARD_PARTNER_ZONE:
        case SCRATCHCARD_FAQ:
        case SCRATCHCARD_CONTACT:
        case SCRATCHCARD_I_SCRATCH:
            return isProfileIScratchCardEnabled() ? <ArticleHeader /> : <LotteryHeader active={route} />;
        case PROMO_CMS:
        case PROMO_CMS_TABLES:
        case PROMO_CMS_SCHEDULE:
        case PROMO_CMS_BETS:
        case ARTICLE_ARCHIVE:
            return <UserBoardHeader pageHeaderClassName="non-shadow" />;
        case NIKE1:
        case VIRTUAL_GAMES:
            return <NikeOneHeader active={route} />;
        case CASINO_GAME_KASINO_CATEGORY:
        case CASINO_GAME_HRY_CATEGORY:
        case CASINO_HRY_LOBBY:
        case CASINO_LOBBY:
            return <CasinoHeader active={route} />;
        case NIKE1_FAV:
        case CASINO_FAVORITE:
        case FAVORITES_HISTORY:
            return <FavoritesHeader active={route} />;
        case MY_TICKETS:
        case SAVED_TICKETS:
            return <TicketsOverviewHeader active={route} />;
        case MENU:
            return <SimplePageHeader searchButtonActive />;
        case NIKE1_TOURNAMENT:
        case NIKE1_MENU_ITEM_TOURNAMENT:
            return <SimplePageHeader />;
        case TV_NIKE_STREAM_OVERVIEW:
        case LIVE_STREAMS:
        case TV_NIKE_ARCHIVE_OVERVIEW:
        case TV_NIKE_HIGHLIGHTS_OVERVIEW:
            return <NikeTvHeader active={route} />;
        case MONEY_WITHDRAWAL:
        case MONEY_DEPOSIT:
        case MONEY_TRANSFER:
            return <MyMoneyHeader active={route} />;
        case TOURNAMENTS:
        case TOURNAMENTS_REWARDS:
            return <TournamentHeader active={route} />;
        case COMMUNITY_LOBBY:
        case COMMUNITY_ANALYSES:
        case BETBOOK_TICKETS:
        case COMMUNITY_CHAT:
            return <CommunityHeader active={route} />;
        case CONTACT_US:
        case CONTACT_US_INFO:
        case OFFICES:
            return <ContactsAndOfficesHeader active={route} />;
        case BONUS_DASHBOARD_CURRENT:
        case BONUS_DASHBOARD_HISTORY:
            return <BonusDashboardHeader active={route} />;
        case ACCOUNT_PROFILE:
        case ACCOUNT_PASSWORD:
        case ACCOUNT_SETTINGS:
            return <ProfileHeader active={route} />;
        case NOTIFIED_MATCHES:
        case NOTIFIED_TICKETS:
            return <NotificationsHeader active={route} />;
        case BRING_FRIENDS:
            return <BringFriendsHeader />;
        case COMMUNITY_POSTS_AUTHOR:
            return <BetbookPostAuthorHeader />;
        case NIKE1_MATCH:
        case NIKE1_DETAIL:
        case CASINO_GAME_DETAIL:
        case COMMUNITY_ANALYSIS_DETAIL:
        case COMMUNITY_TICKET_DETAIL:
        case TOURNAMENTS_RANKING:
        case TOURNAMENTS_TICKETS:
        case TURBO_LIVE_SPORT:
        case TURBO_LIVE_FAVORITES:
        case TURBO_LIVE_MATCH_DETAIL:
        case COMMUNITY_TOP_EVENTS:
        case TV_NIKE_STREAM_DETAIL:
        case TV_NIKE_ARCHIVE_DETAIL:
        case TV_NIKE_HIGHLIGHTS_DETAIL:
        case CASINO_GAME_ENDED:
        case SCRATCHCARD_I_SCRATCH_PLAY:
        case GOAL_OF_MONTH:
            return null;
        case MARKETING_ARTICLE:
            return <ArticleHeader />;
        default:
            return <SimplePageHeader />;
    }
});

export default TopHeader;
